import { useState } from 'react';
import type { LotTargetCountry } from '@produzionejb/types';
import { useLots } from '../lib/lots-api';

export function LotPicker({
  value,
  valueCode,
  onChange,
  disabled,
  targetCountry,
}: {
  value: string;
  valueCode?: string;
  // onChange riceve anche productId per consentire al chiamante (es. MSS/MSF form)
  // di derivare il catalogo SKU per il prodotto del lotto.
  onChange: (id: string, code: string, productId: string) => void;
  disabled?: boolean;
  // Se passato, il picker mostra solo lotti con Lot.targetCountry == questo valore
  // OPPURE targetCountry == null (lotti non pre-allocati a un mercato).
  // Usato da MSS (ES) e MSF (FR) per filtrare la lista lotti.
  targetCountry?: LotTargetCountry;
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const lotsQ = useLots({
    pageSize: 20,
    ...(search.trim() && { search: search.trim() }),
    status: 'ACTIVE',
    ...(targetCountry && { targetCountry }),
  });
  const display = valueCode || (value ? value.slice(0, 8) : '');
  return (
    <div className="relative">
      <button
        type="button"
        className="w-full rounded-md border border-slate-300 px-2 py-1 text-left text-xs"
        onClick={() => !disabled && setOpen((v) => !v)}
        disabled={disabled}
      >
        {display || '— scegli —'}
      </button>
      {open && (
        <div className="absolute z-10 mt-1 w-72 rounded-md border border-slate-300 bg-white p-2 shadow-lg">
          <input
            autoFocus
            type="text"
            className="mb-2 block w-full rounded border border-slate-300 px-2 py-1 text-xs"
            placeholder="Cerca lotto..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <ul className="max-h-56 overflow-y-auto text-xs">
            {lotsQ.isLoading && <li className="p-1 text-slate-400">Caricamento...</li>}
            {lotsQ.data && lotsQ.data.items.length === 0 && (
              <li className="p-1 text-slate-400">Nessun risultato</li>
            )}
            {lotsQ.data?.items.map((l) => (
              <li
                key={l.id}
                className="cursor-pointer rounded p-1 hover:bg-slate-100"
                onClick={() => {
                  onChange(l.id, l.code, l.productId);
                  setOpen(false);
                  setSearch('');
                }}
              >
                <span className="font-mono">{l.code}</span>
                <span className="ml-2 text-slate-500">{l.productCode}</span>
                <span className="ml-2 text-slate-400">res {Number(l.residualQty).toFixed(0)}g</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
